import { render, staticRenderFns } from "./style-guide.vue?vue&type=template&id=8052ffc8&"
import script from "./style-guide.js?vue&type=script&lang=js&"
export * from "./style-guide.js?vue&type=script&lang=js&"
import style0 from "./style-guide.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports